import { FC, ReactElement } from "react";
import { Box } from "@mui/material";
import { TreeItemProps } from "@mui/lab/TreeItem";
import { NavLink as RouterNavLink } from "react-router-dom";

import { StyledMuiTreeItem } from "./styled";

interface IStyledTreeItem {
  startIcon?: ReactElement;
  startIconColor?: string;
  navLink?: string;
  isSelected?: boolean;
  width: number;
  height: number;
  compact?: boolean;
  onClick?: (event: any) => void;
}

interface IWrapper {
  children?: ReactElement;
  navLink?: string;
}

const LinkWrapper: FC<IWrapper> = ({ children, navLink }) => {
  if (navLink) {
    return <RouterNavLink to={navLink}>{children}</RouterNavLink>;
  }

  return <>{children}</>;
};

export const StyledTreeItem = (props: TreeItemProps & IStyledTreeItem) => {
  const {
    children,
    isSelected = false,
    startIcon,
    startIconColor = "#FF0000",
    navLink,
    label,
    width,
    height,
    compact = false,
    onClick = () => {},
    ...rest
  } = props;

  return (
    <StyledMuiTreeItem
      {...rest}
      isSelected={isSelected}
      label={
        <LinkWrapper navLink={navLink}>
          <Box
            onClick={onClick}
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              minWidth: 0,
              p: compact ? "2px 0" : 0.5,
              pr: 0,
            }}
            color="inherit"
          >
            {startIcon ? (
              <Box
                component="span"
                sx={{
                  color: startIconColor,
                  width,
                  height,
                  mr: compact ? 0.5 : 1,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  "& > svg": {
                    width: "100%",
                    height: "100%",
                    display: "block",
                  },
                }}
              >
                {startIcon}
              </Box>
            ) : null}
            <Box sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>{label}</Box>
          </Box>
        </LinkWrapper>
      }
    >
      {children}
    </StyledMuiTreeItem>
  );
};
